import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useQuerySelector } from '@src/hooks/useQuerySelector';

/*
  This hook is used to check if the HeadlessUI portal is ready.
  Needed as rendering HeadlessUI dialogs on the server side can cause unexpected behavior.
*/
export function useHeadlessUIReady() {
  const $ = _c(3);
  const [isReady, setIsReady] = useState(false);
  const headlessUIRootElement = useQuerySelector("#headlessui-portal-root");
  const isHeadlessUILoaded = (headlessUIRootElement?.children?.length ?? 0) > 0;
  let t0;
  let t1;
  if ($[0] !== isHeadlessUILoaded) {
    t0 = () => {
      if (isHeadlessUILoaded) {
        const timeout = setTimeout(() => {
          setIsReady(true);
        }, 300);
        return () => clearTimeout(timeout);
      }
    };
    t1 = [isHeadlessUILoaded];
    $[0] = isHeadlessUILoaded;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isReady;
}